package kz.dentalcrm.app.screens.patients.add

import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.error_message
import dentalcrm.composeapp.generated.resources.snackbar_patient_added
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.utils.stateHandle
import kz.dentalcrm.app.domain.AppointmentRepository
import kz.dentalcrm.app.screens.patients.add.mvi.AddPatientViewEvent
import kz.dentalcrm.app.screens.patients.add.mvi.AddPatientViewSideEffect
import kz.dentalcrm.app.screens.patients.add.mvi.AddPatientViewState
import kz.dentalcrm.app.theme.SnackbarController
import kz.dentalcrm.app.theme.SnackbarEvent
import org.jetbrains.compose.resources.getString
import org.koin.core.component.inject

class AddPatientModel : BaseStateViewModel<AddPatientViewEvent, AddPatientViewState, AddPatientViewSideEffect>() {

    private val appointmentRepository: AppointmentRepository by inject()

    override fun setInitialState() = AddPatientViewState()

    override fun handleEvents(event: AddPatientViewEvent) {
        when (event) {
            is AddPatientViewEvent.AddPatient -> addPatient(event.name, event.surname, event.phone)
        }
    }

    private fun addPatient(name: String, surname: String, phone: String) {
        setState { copy(isLoading = true) }
        launch {
            appointmentRepository.searchPatients(search = phone).stateHandle {
                it.data.firstOrNull()?.let { patient ->
                    setState { copy(isLoading = false) }
                    setEffect { AddPatientViewSideEffect.PatientAdded(patient) }
                } ?: appointmentRepository.addPatient(name, surname, phone).stateHandle(
                    onError = { _, err ->
                        setState { copy(isLoading = false) }
                        SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    },
                    onFailure = {
                        setState { copy(isLoading = false) }
                        SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    },
                    onSuccess = { data ->
                        setState { copy(isLoading = false) }
                        SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.snackbar_patient_added), SnackbarEvent.SnackbarType.Green))
                        setEffect { AddPatientViewSideEffect.PatientAdded(data) }
                    }
                )
            }
        }
    }
}
